import { Dialog as SheetPrimitive } from '@base-ui/react/dialog';

import { cn } from '@/lib/utils';

export type SheetDescriptionProps = SheetPrimitive.Description.Props;

const SheetDescription = ({ className, ...props }: SheetDescriptionProps) => {
  return (
    <SheetPrimitive.Description
      data-slot="sheet-description"
      className={cn('text-sm text-gray-600', className)}
      {...props}
    />
  );
};

export default SheetDescription;
